import './App.css'
//import Register from "./pages/Register/Register";
import Register from './pages/Register/Register'
import Home from './pages/Home/Home'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useContext } from 'react'
import { AuthContext } from './context/AuthContext'

function App() {
  const { curUser } = useContext(AuthContext)

  console.log(curUser)

  const ProtectedRoute = ({ children }) => {
    if (!curUser) {
      return <Navigate to="/Register" />
    }
    return children
  }

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route
              index
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route path="register" element={<Register />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App
